module.exports = __webpack_public_path__ + "img/check-double-1.86c70f58.svg";